export enum SectionTitles {
    ReadyForQc = 'Ready for QC',
    InQc = 'In QC',
    QcFailed = 'QC Failed',
    QcCompleteTwo = 'Done last 2 weeks',
}
